module.exports = __webpack_public_path__ + "components/flag/static/square/eg-d8ce12689f70e36e7459ca221d8982f8.svg";